export default __webpack_public_path__ + "static/media/edit.d0edda1c.svg";